import React from 'react';
import SiteHeader from '../Views/SiteHeader';
import ContactFooter from '../Components/ContactFooter';
import MotionCv from './MotionCv';
import './About.css';

const About = () => {
  return (
    <div className="contact-container">
      <SiteHeader />
      <MotionCv />
      <ContactFooter />
    </div>
  );
};

export default About;
